<template>
  <header class="header">
    <nav class="navbar navbar-default">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <router-link class="nav-link my-1" :to="{ name: 'About' }">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </router-link>
          </button>
          <router-link class="navbar-brand" :to="{ name: 'Index' }">
            <img
              :src="require('../assets/images/logo.png')"
              class="logo"
              alt=""
            />
          </router-link>
        </div>
        <div
          id="navbar"
          class="navbar-collapse collapse"
          aria-expanded="false"
          style="height: 1px;"
        >
          <ul class="nav navbar-nav navbar-right">
            <li class="">
              <router-link class="nav-link my-1" :to="{ name: 'About' }">
                About this directory</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>



// WEBPACK FOOTER //
// src/elements/Header.vue